module.exports = __webpack_public_path__ + "media/images/icons/gf-mod-zoom_out-sharp-63ae1f6beb9532be5273c0a370c7457c.svg";